module.exports = __webpack_public_path__ + "static/img/kalenji-by-decathlon.05ebd42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kalenji-by-decathlon.svg
// module id = 433
// module chunks = 1